// src/components/Home.js
import React, { useState, useRef, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import "../Style/Responsive.css";
import CookieConsentBanner from "./CookieConsentBanner";
import ParticleNetwork from "./ParticleNetwork";
import Chatbot from "./Chatbot";

// import antlerimage from "../antler-logo-red.svg";
// import partner1 from "../Images/image (2).png";
// import partner2 from "../Images/image (11).png";
// import partner3 from "../Images/image (12).png";
// import partner4 from "../Images/image (13).png";
// import partner6 from "../Images/image (15).png";
// import partner8 from "../Images/image (17).png";
// import partner10 from "../Images/image (1).png";
// import partner12 from "../Images/strath.png";

//Thought leadership images

import venturepulse from "../Images/optimized/venturepulse1.jpg";
import familybiz from "../Images/optimized/Familybusiness.jpg";
import ceo from "../Images/optimized/ceooutlook.jpg";
import startup from "../Images/optimized/Start-upIPO.jpg";
import founders from "../Images/optimized/horizonfounders.jpg";
import leadingpurpose from "../Images/optimized/Leadingpurpose.jpg";
import pitch from "../Images/optimized/Perfectpitch.jpg";
import insightlive from "../Images/optimized/insightlive.jpg";
import EMI from "../Images/optimized/shutterstock_2033568851.jpg";
import BYND from "../Images/optimized/BYNDMagazine.jpg";

//Benefits of joining centre of excellence images
import benefit1 from "../Images/optimized/Matchmaking.jpg";
import benefit2 from "../Images/optimized/2024-5-Emerging-Programs.jpg";
import benefit3 from "../Images/optimized/Pitching.jpg";
import benefit4 from "../Images/optimized/Expert support.jpg";

// Featured event image
import ventureSummit from "../Images/optimized/KPMG Africa Private Enterprise Venture Summit.png";

//import videos
import video1 from "../Images/optimized/Dynamic Tax Collaboration.mp4";

//Social media icons
import {
  FaLinkedin,
  FaFacebook,
  FaGlobe,
} from "react-icons/fa";
import { useLanguage } from "../contexts/LanguageContext";

// Section icons
import connectIcon from "../icons/connect-icon.png";
import strengthenIcon from "../icons/strengthen-icon.png";
import informIcon from "../icons/inform-icon.png";
import coordinateIcon from "../icons/coordinate-icon.png";
import innovatorsIcon from "../icons/innovators&enterprises-icon.png";
import investorsIcon from "../icons/investors-icon.png";
import regulatorsIcon from "../icons/Regulators&EcosystemPartners-icon.png";

//Thought leadership data
const thoughtLeadershipData = [
  {
    title: "Venture Pulse Report – Global trends",
    link: "https://kpmg.com/xx/en/our-insights/operations/q2-venture-pulse-report-global.html",
    image: venturepulse, // Placeholder image
  },
  {
    title: "Family Business Leadership Academy",
    link: "https://kpmg.com/uk/en/industries/private-enterprise/family-business.html",
    image: familybiz, // Placeholder image
  },
  {
    title: "The art of the perfect pitch",
    link: "https://kpmg.com/uk/en/home/insights/2024/06/the-art-of-the-perfect-pitch.html",
    image: pitch, // Placeholder image
  },
  {
    title: "2024 - what’s on the horizon for founders and their businesses?",
    link: "https://kpmg.com/uk/en/home/insights/2024/02/2024-whats-on-the-horizon-for-founders-and-their-businesses.html",
    image: founders, // Placeholder image
  },
  {
    title: "KPMG 2024 CEO Outlook: The private company perspective",
    link: "https://kpmg.com/xx/en/our-insights/value-creation/kpmg-2024-ceo-outlook-the-private-company-perspective.html",
    image: ceo, // Placeholder image
  },
  {
    title: "Leading with purpose",
    link: "https://kpmg.com/uk/en/home/insights/2024/06/leading-with-purpose.html",
    image: leadingpurpose, // Placeholder image
  },
  {
    title: "From start-up to IPO: the funding landscape in the North West",
    link: "https://kpmg.com/uk/en/blogs/home/posts/2024/05/from-start-up-to-ipo-the-funding-landscape-in-the-north-west.html",
    image: startup, // Placeholder image
  },

  {
    title: "BYND Magazine: Edition 1, Oct 2024",
    link: "https://issuu.com/docs/32b76387a7a0fac33817914c921ee95a",
    image: BYND, // Placeholder image
  },

  {
    title:
      "Notifying EMI option grants to HMRC – you may need to act by 7 July",
    link: "https://kpmg.com/uk/en/home/insights/2024/06/tmd-notifying-emi-option-grants-to-hmrc-you-may-need-to-act-by-7-july.html",
    image: EMI, // Placeholder image
  },

  {
    title: "Insights for leaders digital events",
    link: "https://kpmg.com/uk/en/home/insights/2022/05/insights-for-leaders.html",
    image: insightlive, // Placeholder image
  },
];

function Home() {
  const isLoggedIn = Boolean(localStorage.getItem("token"));
  const { t } = useLanguage();

  // Native-scroll carousel: arrows drive scrollBy on the track,
  // browser handles bounds + smooth scrolling + touch.
  const carouselRef = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  const updateBounds = useCallback(() => {
    const el = carouselRef.current;
    if (!el) return;
    const maxScrollLeft = el.scrollWidth - el.clientWidth;
    setAtStart(el.scrollLeft <= 1);
    setAtEnd(el.scrollLeft >= maxScrollLeft - 1);
  }, []);

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;
    updateBounds();
    el.addEventListener("scroll", updateBounds, { passive: true });
    window.addEventListener("resize", updateBounds);
    return () => {
      el.removeEventListener("scroll", updateBounds);
      window.removeEventListener("resize", updateBounds);
    };
  }, [updateBounds]);

  const scrollByPage = (direction) => {
    const el = carouselRef.current;
    if (!el) return;
    // Scroll by ~80% of the visible width so the user always keeps a
    // partially-visible card as a visual anchor between pages.
    const delta = el.clientWidth * 0.8 * direction;
    el.scrollBy({ left: delta, behavior: "smooth" });
  };

  const handlePrev = () => scrollByPage(-1);
  const handleNext = () => scrollByPage(1);

  return (
    <div
      className="App"
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    >
      {/* Hero Section */}
      <section className="hero-section" id="home">
        {/* Video Background */}
        <div className="video-background">
          <video autoPlay muted loop playsInline className="background-video">
            <source src={video1} type="video/mp4" />
            <source src="/src/Images/your-video.webm" type="video/webm" />
            Your browser does not support the video tag.
          </video>
          <div className="video-overlay"></div>
        </div>

        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Welcome to KPMG’s Africa Centre&nbsp;of&nbsp;Excellence</h1>
            <p>
              Plug into a dynamic network of visionary investors, bold
              entrepreneurs, and KPMG-led programs designed to accelerate your
              venture and investments to the next frontier of growth.
            </p>
            <div className="cta-buttons">
              {isLoggedIn ? (
                <button id="btn-primary" className="disabled-link" disabled>
                  Join Now
                </button>
              ) : (
                <a href="/register" id="btn-primary">
                  Join Now
                </a>
              )}

              {isLoggedIn ? (
                <button id="btn-secondary" className="disabled-link" disabled>
                  Explore Programs
                </button>
              ) : (
                <a href="/programs" id="btn-secondary">
                  Explore Programs
                </a>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Vision Statement */}
      <section className="vision-section" id="vision">
        <div className="vision-container">
          <span className="vision-eyebrow">Our Purpose</span>
          <h2>
            A Pan-African platform connecting capital, innovation and insight.
          </h2>
          <p>
            Innovation continues to grow across Africa — in agriculture,
            financial services, climate and green finance, health, logistics
            and MSMEs. Yet ecosystems remain fragmented, many ventures find it
            difficult to reach credible investors, and timely market
            intelligence can be hard to access. The KPMG Africa Centre of
            Excellence helps bring these worlds together: a neutral,
            professionally curated platform designed to support investment,
            strengthen institutional capacity and inform decision-making across
            the continent.
          </p>
          <div className="vision-pillars">
            <div className="vision-pillar pillar-blue">
              <img src={connectIcon} alt="" className="vision-pillar-icon" />
              <h4>{t('pillar_connect')}</h4>
              <p>{t('pillar_connect_desc')}</p>
            </div>
            <div className="vision-pillar pillar-green">
              <img src={strengthenIcon} alt="" className="vision-pillar-icon" />
              <h4>{t('pillar_strengthen')}</h4>
              <p>{t('pillar_strengthen_desc')}</p>
            </div>
            <div className="vision-pillar pillar-purple">
              <img src={informIcon} alt="" className="vision-pillar-icon" />
              <h4>{t('pillar_inform')}</h4>
              <p>{t('pillar_inform_desc')}</p>
            </div>
            <div className="vision-pillar pillar-ocean">
              <img src={coordinateIcon} alt="" className="vision-pillar-icon" />
              <h4>{t('pillar_coordinate')}</h4>
              <p>{t('pillar_coordinate_desc')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Serve */}
      <section className="audience-section" id="who-we-serve">
        <div className="audience-container">
          <span className="vision-eyebrow">{t('serve_title')}</span>
          <h2>{t('serve_subtitle')}</h2>
          <p className="audience-intro">{t('serve_intro')}</p>

          <div className="audience-cards">
            <div className="audience-card audience-blue">
              <div className="audience-icon-wrap">
                <img src={innovatorsIcon} alt="" className="audience-icon" />
              </div>
              <h3>{t('serve_innovators')}</h3>
              <p className="audience-tagline">{t('serve_innovators_tagline')}</p>
              <ul>
                <li>
                  Smart matchmaking with investors aligned to your sector,
                  stage, ticket size and geography
                </li>
                <li>
                  Investment-ready profiles and structured data rooms aligned
                  with institutional investor expectations
                </li>
                <li>
                  Trade Connect for cross-border partnerships, customers and
                  capital flows
                </li>
                <li>
                  Access to KPMG-led programs, mentorship and curated knowledge
                </li>
              </ul>
            </div>

            <div className="audience-card audience-green">
              <div className="audience-icon-wrap">
                <img src={investorsIcon} alt="" className="audience-icon" />
              </div>
              <h3>{t('serve_investors')}</h3>
              <p className="audience-tagline">{t('serve_investors_tagline')}</p>
              <ul>
                <li>
                  Curated, structured deal flow across multiple African markets
                  and sectors
                </li>
                <li>
                  Filter opportunities by geography, sector, stage, ticket size
                  and impact theme
                </li>
                <li>
                  Sector and country intelligence to support pipeline
                  development and investment theses
                </li>
                <li>
                  Visibility into co-investment opportunities and aligned
                  capital partners
                </li>
              </ul>
            </div>

            <div className="audience-card audience-purple">
              <div className="audience-icon-wrap">
                <img src={regulatorsIcon} alt="" className="audience-icon" />
              </div>
              <h3>{t('serve_regulators')}</h3>
              <p className="audience-tagline">{t('serve_regulators_tagline')}</p>
              <ul>
                <li>
                  A wide-ranging view of innovators, investors and sectoral
                  trends to support policy and programming
                </li>
                <li>
                  Onboard cohorts and report on outcomes — climate ventures,
                  women-owned MSMEs, AgTechs and more
                </li>
                <li>
                  Knowledge products, webinars and capacity-building on
                  innovation, risk and regulation
                </li>
                <li>
                  Neutral collaboration space for transparent multi-stakeholder
                  engagement
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Event Banner */}
      <section className="featured-event" id="featured-event">
        <div className="featured-event-stripe" aria-hidden="true"></div>
        <div className="featured-event-orbs" aria-hidden="true">
          <span className="orb orb-pink"></span>
          <span className="orb orb-purple"></span>
          <span className="orb orb-ocean"></span>
          <span className="orb orb-green"></span>
        </div>
        <div className="featured-event-grid">
          <div className="featured-event-content">
            <span className="featured-event-eyebrow">
              <span className="pulse-dot" aria-hidden="true"></span>
              Upcoming Summit · 2026
            </span>
            <h2>
              KPMG Africa Private Enterprise <br />
              <span className="gradient-text">Venture Summit</span>
            </h2>
            <p className="featured-event-tagline">
              Africa Accelerated — powering Africa's engines of growth.
            </p>
            <p className="featured-event-description">
              A flagship gathering of innovators, investors, regulators and
              ecosystem partners shaping the next chapter of Africa's growth
              story. Join the conversation, explore curated deal flow, and
              connect with the people building Africa's future.
            </p>
            <div className="featured-event-actions">
              <a
                href="https://kpmg.com/ke/en/insights/2026/05/2026-kpmg-africa-private-enterprise-venture-summit.html"
                className="featured-event-cta"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="cta-label">Click here to participate</span>
                <span className="cta-arrow" aria-hidden="true">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 6l6 6-6 6"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </a>
            </div>
          </div>
          <div className="featured-event-visual">
            <div className="featured-event-image-frame">
              <img
                src={ventureSummit}
                alt="KPMG Africa Private Enterprise Venture Summit 2026"
                loading="lazy"
              />
              <div className="featured-event-glow" aria-hidden="true"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Benefits Section */}
      <section className="key-benefits" id="about">
        <div className="benefits-content">
          <h2>Why Join Centre of Excellence?</h2>
          <div className="benefit-cards">
            <div className="benefit-card">
              <img
                src={benefit1}
                alt="Matchmaking Icon"
                className="benefit-icon"
              />
              <h3>Matchmaking</h3>
              <p>Find the right investors tailored to your business sector.</p>
            </div>

            <div className="benefit-card">
              <a href="/programs" target="_blank" rel="noopener noreferrer">
                <img
                  src={benefit2}
                  alt="Programs Icon"
                  className="benefit-icon"
                />
              </a>
              <h3>Programs</h3>
              <p>
                Exclusive access to ecosystem programs designed to scale
                businesses.
              </p>
            </div>

            <div className="benefit-card">
              <img
                src={benefit3}
                alt="Speed Pitching Icon"
                className="benefit-icon"
              />
              <h3>Speed Pitching</h3>
              <p>
                Present your business to investors and receive feedback
                instantly.
              </p>
            </div>

            <div className="benefit-card">
              <a href="/contact" rel="noopener noreferrer">
                <img
                  src={benefit4}
                  alt="Expert Support Icon"
                  className="benefit-icon"
                />
              </a>
              <h3>Expert Support</h3>
              <p>
                Get guidance from industry experts to become investment-ready.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* KPMG footprint Slideshow Section */}
      <section className="video-slideshow" id="videos">
        <h2>KPMG Private Enterprise Footprint</h2>
        <hr className="videoslide-divider" />
        <div className="video-carousel">
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7461377206020308992?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7461800531154518016?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7461821897069195264?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7461758845929967616?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7461759297421520896?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7461800571969134592?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7462740721679224832?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7462908949411819520?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7463098882596511745?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7463100200505516034?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7463101152478507009?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7462908949411819520?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7463242816828145664?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7463263473293086720?collapsed=1" height="541" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7333090266389569536?collapsed=1"
            height="578"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7314925318643814400?compact=1"
            height="399"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7332667313449521152?compact=1"
            height="399"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7332826624754716673?compact=1"
            height="399"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7332692729849610241?compact=1"
            height="399"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7332401084742656000?collapsed=1"
            height="543"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7332805087448215554?collapsed=1"
            height="578"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7327961900653146113?compact=1"
            height="399"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7332804868430024704?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333764463092727810?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7327648265624027136?compact=1"
            height="399"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7314925318643814400?compact=1"
            height="399"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333830168513351680?compact=1"
            height="399"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7333080596706910209?collapsed=1"
            height="578"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7332403501265768449?collapsed=1"
            height="543"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333513960702275584?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333513875625013249?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7334225698909241344?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333140223373086720?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7334225698909241344?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333456677226070017?collapsed=1"
            height="877"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333061433263394816?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333352546901692417?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333513960702275584?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7333451745785806848?collapsed=1"
            height="877"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7329834207805857792?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7255625503250735133?collapsed=1"
            height="542"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7323641099791568897?collapsed=1"
            height="755"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7330870901111988226?collapsed=1"
            height="916"
            width="504"
            frameborder="0"
            allowfullscreen=""
            title="Embedded post"
          ></iframe>
          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/8jaURnfaMes?list=PLNOgux_JrCkKP2CCRFGp81L5SDKL4iTcp"
            title="Chad Pollock - Vice President, VISA EA"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; 
          gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          >
            {" "}
          </iframe>

          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/KrTq9AUwSNs?list=PLNOgux_JrCkKP2CCRFGp81L5SDKL4iTcp"
            title="Zipporah Muceke - Senior  Business Advisor, KPMG East Africa"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media;
            gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/Vosn1VXxc1s?list=PLNOgux_JrCkKP2CCRFGp81L5SDKL4iTcp"
            title="KPMG Start Up Centre of Excellence"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/JccXe0RW4hI?list=PLNOgux_JrCkKP2CCRFGp81L5SDKL4iTcp"
            title="Victor Maina - CEO &amp; Founder, DUHQA"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/Y_kT7wAbUkY?list=PLNOgux_JrCkKP2CCRFGp81L5SDKL4iTcp"
            title="Hamza Butt - Investment Principal, Chandaria Capital"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/T-iolMOP7Os?list=PLNOgux_JrCkKP2CCRFGp81L5SDKL4iTcp"
            title="Joan Mwangi - Program Manager, iHub"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/OYSx9z0iV64"
            title="KPMG Private Enterprise Family Business Survey 2024"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/_bpemvXypps"
            title="KPMG Private Enterprise Venture Pulse Q2 2024 Highlights (:30)"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/IoKcmqLm1NQ?list=PLNOgux_JrCkKP2CCRFGp81L5SDKL4iTcp"
            title="Waithera Gaitho - Executive Director, Alternatives Africa"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; 
          gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <iframe
            width="942"
            height="530"
            src="https://www.youtube.com/embed/jw_st1e1JTs?list=PLNOgux_JrCkKP2CCRFGp81L5SDKL4iTcp"
            title="Nikita Waruguru - Africa Program Manager, Argidius Foundation"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media;
           gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          <iframe
            width="530"
            height="315"
            src="https://www.youtube.com/embed/ioT3q71oEPE"
            title="KPMG Private Enterprise Tech Innovator in the US 2024"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
        <hr className="videoslide-divider" />
      </section>

      {/* Thought Leadership Section */}
      <section className="thought-leadership" id="thought-leadership">
        <ParticleNetwork />
        <h2 id="insight-title">Insights &amp; Thought Leadership</h2>
        {/* Updated Insights & Thought Leadership carousel */}
        <div className="carousel-container">
          <button
            className="carousel-arrow prev"
            onClick={handlePrev}
            aria-label="Previous insights"
            disabled={atStart}
          >
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
            </svg>
          </button>

          <div className="thought-leadership-carousel" ref={carouselRef}>
            {thoughtLeadershipData.map((item, index) => (
              <div key={index} className="thought-leadership-card">
                <a
                  href={item.link}
                  className="card-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="image-container">
                    <img src={item.image} alt={item.title} loading="lazy" />
                  </div>
                  <div className="card-content">
                    <h4>{item.title}</h4>
                    <span className="read-more">Read More →</span>
                  </div>
                </a>
              </div>
            ))}
          </div>

          <button
            className="carousel-arrow next"
            onClick={handleNext}
            aria-label="Next insights"
            disabled={atEnd}
          >
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
            </svg>
          </button>
        </div>
      </section>

      {/* Innovation Section */}
      <section className="innovation-section" id="innovation">
        <div className="innovation-container">
          <div className="innovation-image">
            <img src={benefit3} alt="Innovation at KPMG" />
          </div>
          <div className="innovation-content">
            <h2>Innovation at KPMG: The big picture</h2>
            <p>
              KPMG Africa Centre of Excellence is part of KPMG Private
              Enterprise – our enterprise‑wide platform for innovators to
              conceive, incubate, and grow the next generation of businesses.
            </p>
            <p>
              KPMG Africa Centre of Excellence is dedicated to collaborating
              with both the entrepreneurs and investors.
            </p>
            <p>
              We support businesses that we consider to be the world’s most
              promising ventures connecting them to the right match of investors
              while providing access to the experience of KPMG mentors and
              advisers who provide valuable guidance and expertise to navigate
              businness challenges at every life cycle.
            </p>
            <p>
              By bridging the gap between ventures and investors, KPMG Africa
              Centre of Excellence creates durable relationships that help
              future‑proof the businesses we serve.
            </p>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      {/* <section>
        <div id="partners-heading">
          <h2>Ecosystem Partners</h2>
        </div>
        <div id="partners">
          <div className="partners-card">
            <img src={antlerimage} alt="antler" />
          </div>
          <div className="partners-card">
            <img src={partner1} alt="partner 1" />
          </div>
          <div className="partners-card">
            <img src={partner2} alt="partner 2" />
          </div>
          <div className="partners-card">
            <img src={partner3} alt="partner 3" />
          </div>
          <div className="partners-card">
            <img src={partner4} alt="partner 3" />
          </div>
      
          <div className="partners-card">
            <img src={partner6} alt="partner 3" />
          </div>
         
          <div className="partners-card">
            <img src={partner8} alt="partner 3" />
          </div>
       
          <div className="partners-card">
            <img src={partner10} alt="partner 3" />
          </div>
          
          <div className="partners-card">
            <img src={partner12} alt="partner 3" />
          </div>
        </div>
      </section> */}

      {/* Footer Section */}
      <footer id="contact">
        <div className="footer-container">
          <div class="footer-links">
            <ul id="footer-links">
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <a
                  href="/event-calendar"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Events
                </a>
              </li>
              <li>
                <a href="/programs">Programs</a>
              </li>
              <li>
                <a href="/contact" target="_blank" rel="noopener noreferrer">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/support" target="_blank" rel="noopener noreferrer">
                  Help
                </a>
              </li>
              <li>
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="https://kpmg.com/ke/en/home/misc/privacy.html#:~:text=If%20KPMG%20processes%20personal%20information,to%20you%20free%20of%20charge."
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Legal
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>

      <div id="social-links">
        <a
          href="https://www.linkedin.com/company/kpmg-africa/posts/?feedView=all"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin /> LinkedIn
        </a>
        <a href="https://x.com/KPMGEastAfrica">𝕏.com</a>
        <a
          href="https://www.facebook.com/KPMGEA/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebook /> Facebook
        </a>
        <a
          href="https://kpmg.com/ke/en/home.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGlobe /> KPMG East Africa
        </a>
      </div>

      {/* ChatBot Component */}
      <Chatbot />
      {/* Cookie Consent Component */}
      <CookieConsentBanner />
    </div>
  );
}

export default Home;
